import { render } from "./LogoMarquee.vue?vue&type=template&id=d16926ca&scoped=true"
import script from "./LogoMarquee.vue?vue&type=script&lang=js"
export * from "./LogoMarquee.vue?vue&type=script&lang=js"

import "./LogoMarquee.vue?vue&type=style&index=0&id=d16926ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16926ca"]])

export default __exports__